export default __webpack_public_path__ + "static/media/warning-courier-icon.c48fa633.svg";